import { Component, inject, input } from '@angular/core';
import { WindowService } from '@shared/services/window.service';

@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrl: './page-header.component.css',
    host: {
        '[class.scrolled]': 'scrolled()',
    },
})
export class PageHeaderComponent {
    private windowService = inject(WindowService);

    scrolled = this.windowService.scrolled;

    title = input.required<string>();
    description = input<string>();
}
